import React from 'react'

import PropTypes from 'prop-types'

import './head2.css'

const Head2 = (props) => {
  return (
    <figure className={`head2-container ${props.rootClassName} `}>
      <div className="head2-max-width thq-flex-row thq-section-max-width">
        <div className="head2-container1">
        <video autoPlay loop muted className="head2-video">
            <source src={props.videoSrc} type="video/mp4" />
          </video>
          <h1 className="head2-text thq-heading-1">{props.heading}</h1>
        </div>
      </div>
    </figure>
  )
}

Head2.defaultProps = {
  heading: 'About us',
  videoSrc: '/cloud.mp4',
  rootClassName: '',
}

Head2.propTypes = {
  heading: PropTypes.string,
  videoSrc: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Head2
